<template>
  <div class="support-chat__container">
    <div class="support-chat">
      <div
        class="support-chat-navigation"
        :class="{'hidden':isChatOpen}"
      >
        <div class="support-chat-navigation__search">
          <input
            placeholder="search for..."
            v-model="searchTerm"
            @keyup.esc="searchTerm = ''"
          />

          <CElementCover
            v-if="loading"
            :opacity="0.8"
            :boundaries="[{ sides: ['top', 'left'], query: '.support-chat-navigation' }]"
          />
        </div>
        <div v-if="filteredChats.length > 0">
          <div
          v-for="chat in filteredChats"
          :key="`chat-${chat.id}`"
          @click="openChat(chat)"
          class="support-chat-navigation__user"
          :class="{'selected-chat': isSelected(chat)}"
        >
          <div
            v-if="chat.unreadCount > 0"
            class="support-chat-navigation__user-unread"
          >
            <span>{{chat.unreadCount}}</span>
          </div>
          <div class="support-chat-navigation__user-icon">
            <VUserIcon :src="chat.userAvatar" />
          </div>
          <div class="user-container d-flex position-relative">
            <div class="support-chat-navigation__user-username">{{chat.username}}</div>
          <div class="support-chat-delete " @click="deleteCurrentChannel($event, chat)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Delete"><path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z" fill="#d85b53" class="color000000 svgShape"></path></svg>
          </div>
          </div>
          
         
        </div>
        </div>
        
        <div v-if="filteredChats.length === 0 && !loading" class="text-black-50 text-left">
          <b>Not found chats</b>
        </div>
      </div>
      <div
        class="support-chat-messages"
      >
        <div class="support-chat__header">
          <button
            class="support-chat__back"
            :class="{'hidden': !isChatOpen}"
            @click="closeChat"
          >
            Back
          </button>

          <span :class="{'hidden': !isChatOpen}" class="support-chat__name">{{ selectedChannel && selectedChannel.friendlyName }}</span>
        </div>

        <TheChatMessagesList 
          v-show="selectedChannel" 
          :loading="loadingMessages" 
        >
        </TheChatMessagesList>
        <div 
          v-if="!selectedChannel"
          class="d-flex justify-content-center align-items-center h-100 text-black-50 support-chat-messages__placeholder"
        ><b>Please, select chat</b></div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalType from '@/utils/dictionaries/modalType'
import TheChatMessagesList from './TheChatMessagesList'
import {
  createSupportStoreMixin,
  supportStore
} from '@/mixins/supportMixin'
import _ from 'lodash'
import moment from "moment"
export default {
  name: 'TheChat',

  mixins: [createSupportStoreMixin()],

  components: {
    TheChatMessagesList
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isChatOpen: false,
      loadingMessages: false,
      searchTerm: null
    }
  },

  computed: {
    filteredChats() {
      const filteredBySearch = this.searchTerm ? this.chats.filter(c => c.username.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0) : this.chats
      // const sortedByUnread = filteredBySearch.sort((a, b) => {
      //   console.log("a",a)
      //   console.log("b",b)
      //   const lastMessageDiff = Date.parse(b?.lastMsg?.dateCreated) - Date.parse(a?.lastMsg?.dateCreated)
      //   return isNaN(lastMessageDiff) ? 0 : lastMessageDiff
      // })
      const sortedByUsername = _.sortBy(filteredBySearch,'username', 'desc' )
      const sortedByUnread = _.orderBy(sortedByUsername, [
        (chat) => chat.lastMsg ? 1 : 0, // Prioritize chats with lastMsg
        (chat) => chat.lastMsg ? moment(chat.lastMsg.dateCreated) : null, // Sort by dateCreated
      ], [
        'desc', // First criterion: sort by existence of lastMsg (1 first)
        'desc', // Second criterion: sort by dateCreated in descending order
      ]);
      console.log("sortedByUnread",sortedByUnread)
      return sortedByUnread
    },
    messages() {
      return this[supportStore.getterTypes.GETTER_MESSAGES];
    },
    chats() {
      return this[supportStore.getterTypes.GETTER_CHANNELS]
    },
    selectedChannel() {
      return this[supportStore.getterTypes.GETTER_SELECTED_CHANNEL]
    }
  },

  watch: {
    loading() {
      this.loadChat()
    },
    $route() {
      this.loadChat()
    }
  },

  methods: {
    deleteCurrentChannel(event, chat) {
      event.stopPropagation();
      const deleting = async () => {
        this[supportStore.actionTypes.ACTION_DELETE_CHANNEL]({currentChannel: chat});
        this.$modals.close(ModalType.ConfirmationModal);
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: "Are you sure you want to delete conversation?",
        buttonText: "Delete",
        onClickButton: deleting
      });
    },
    loadChat() {
      if (!this.loading) {
      const { user } = this.$route.query
        if (user) {
          const chat = this.chats.find(c => c.username === user)
          if (chat) {
            this.openChat(chat)
          }
        }
      }
    },
    search() {

    },

    isSelected (chat) {
      return this.selectedChannel?.id === chat.id
    },

    async openChat(chat) {
      this.isChatOpen = true
      this.loadingMessages = true
      try {
        await this[supportStore.actionTypes.ACTION_SELECT_CHANNEL](chat.id)
        // console.log("this.messages.length",this.messages.length)
        // this[supportStore.actionTypes.ACTION_READ_MESSAGE]({
        // conversation: this.selectedChannel, 
        // messageIndex: this.messages.length
        // });
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingMessages = false
      }
    },

    closeChat () {
      this.isChatOpen = false
    },

    deleteChat(chat) {
      this[supportStore.actionTypes.ACTION_DELETE_CHANNEL](chat)
    }
  },
}
</script>
